import { FunctionComponent } from 'react';

const HiddenInput: FunctionComponent<DynamicForm.HiddenProps> = ({ props }) => {
	return (
		<input { ...props } />
	);
};

export default HiddenInput;
